<template>
  <span
    class="primary cur"
    @click="displayChildItem"
  >{{ctrlFoldContent[`${$route.fullPath}`] ? '收起' : '展开'}}</span>
</template>

<script>
export default {
  props: {
    // 需要控制的表单
    ctrlForm: {
      type: Object,
      default: () => ({}),
    },
    // 要控制的子项
    childItemList: {
      type: Array,
      default: () => ([]),
    },
    // 是否默认显示内容，默认显示
    defaultContentShow: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    // 根据监听地址来作为 key 值去设置显示隐藏
    '$route.fullPath': {
      immediate: true,
      handler (newValue, oldValue) {
        const name = `${newValue}`;

        const tabMenu = sessionStorage.getItem('tabMenu');
        const preTabMenuList = this.preTabMenu ? JSON.parse(this.preTabMenu) : [];
        // 查找之前是否打开过这个链接，判断是否第一次进来
        const tabIndex = preTabMenuList.findIndex((item) => item.url === newValue);
        if (tabIndex === -1) {
          this.$set(this.ctrlFoldContent, name, undefined);
        }
        this.preTabMenu = tabMenu;

        if (this.ctrlFoldContent[name] === undefined) {
          // 如果没有设置，就默认显示
          this.setDefaultHideAttr();
          this.$set(this.ctrlFoldContent, name, this.defaultContentShow);
        } else {
          // 来回切换 tab 的时候，回填之前的值
          this.$set(this.ctrlFoldContent, name, this.ctrlFoldContent[name]);
          this.setFormAttrVal({
            form: this.ctrlForm,
            attr: 'hide',
            value: !this.ctrlFoldContent[name],
            names: this.childItemList,
          });
        }
      },
    },
  },
  data () {
    return {
      preTabMenu: '',
      ctrlFoldContent: {},
    };
  },
  methods: {
    // 设置默认 hide 值为隐藏
    setDefaultHideAttr () {
      for (let formItem of this.ctrlForm.form) {
        for (let ctrlItem of this.childItemList) {
          if (formItem.value === ctrlItem) {
            if (!formItem.hide) {
              this.$set(formItem, 'hide', !this.defaultContentShow);
            }
          }
        }
      }
    },
    // 控制子项的显示隐藏
    displayChildItem () {
      const name = `${this.$route.fullPath}`;
      this.$set(this.ctrlFoldContent, name, !this.ctrlFoldContent[name]);
      this.setFormAttrVal({
        form: this.ctrlForm,
        attr: 'hide',
        value: !this.ctrlFoldContent[name],
        names: this.childItemList,
      });
    },
  },
};
</script>

<style scoped lang="scss">
</style>
